import _ from 'lodash';
import {generateGuid} from '@packages/utilities/guid';
import type {Context} from '../types';

export default (context: Context) => {
  const {
    node: {jsonNode},
    tree: {nodeMap},
    fn: {insertNodesAfter},
  } = context;
  const {type, children = []} = jsonNode;
  const needed =
    type === 'CommerceCheckoutOrderItemDescriptionWrapper' &&
    !_.find(jsonNode.children, (childId) => {
      const childNode = nodeMap.get(childId);
      return (
        childNode && childNode.type === 'CommerceCheckoutOrderItemOptionList'
      );
    });

  return {
    needed,
    logData: {
      msg: 'Option List element should be added to every item in the Checkout Order Order Items',
      meta: {
        nodeId: jsonNode._id,
      },
    },
    apply: () => {
      const commerceCheckoutOrderItemOptionListId = generateGuid();
      const commerceCheckoutOrderItemOptionListItemId = generateGuid();
      const commerceCheckoutOrderItemOptionListItemLabelId = generateGuid();
      const commerceCheckoutOrderItemOptionListItemValueId = generateGuid();

      const optionListNode = [
        {
          _id: commerceCheckoutOrderItemOptionListId,
          type: 'CommerceCheckoutOrderItemOptionList',
          tag: 'ul',
          children: [commerceCheckoutOrderItemOptionListItemId],
        },
        {
          _id: commerceCheckoutOrderItemOptionListItemId,
          type: 'CommerceCheckoutOrderItemOptionListItem',
          tag: 'li',
          children: [
            commerceCheckoutOrderItemOptionListItemLabelId,
            commerceCheckoutOrderItemOptionListItemValueId,
          ],
        },
        {
          _id: commerceCheckoutOrderItemOptionListItemLabelId,
          type: 'CommerceCheckoutOrderItemOptionListItemLabel',
          tag: 'span',
        },
        {
          _id: commerceCheckoutOrderItemOptionListItemValueId,
          type: 'CommerceCheckoutOrderItemOptionListItemValue',
          tag: 'span',
        },
      ];

      _.each(children, (childId, index) => {
        const childNode = nodeMap.get(childId);
        if (
          childNode &&
          childNode.type === 'CommerceCheckoutOrderItemQuantityWrapper'
        ) {
          children.splice(index + 1, 0, commerceCheckoutOrderItemOptionListId);
          insertNodesAfter(childId, optionListNode);
        }
      });
    },
  };
};
